/**
 * Must match backend `MFA_STEP_UP_REQUIRED_MESSAGE` (`Wireless-API` `mfa-stepup.constants.ts`).
 * Step-up–protected routes return 401 with this exact message when `mfa_at` is missing or stale.
 */
export const MFA_STEP_UP_REQUIRED_MESSAGE = 'MFA step-up required';
